// Safe markdown rendering for E-Learning lesson content blocks.
// Uses `marked` to convert markdown to HTML and `dompurify` to sanitize
// before injecting into the DOM. Only allowlisted tags survive.

import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({
  breaks: true,
  gfm: true,
  headerIds: false,
  mangle: false,
});

const ALLOWED_TAGS = [
  'a', 'b', 'blockquote', 'br', 'code', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'hr', 'i', 'img', 'li', 'ol', 'p', 'pre', 'span', 'strong', 'table', 'tbody',
  'td', 'th', 'thead', 'tr', 'u', 'ul',
];

const ALLOWED_ATTR = ['href', 'title', 'alt', 'src', 'target', 'rel', 'class'];

export function renderMarkdown(input) {
  const raw = typeof input === 'string' ? input : '';
  if (!raw.trim()) return '';
  const html = marked.parse(raw);
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form'],
    FORBID_ATTR: ['onerror', 'onclick', 'onload', 'onmouseover'],
  });
}

// For non-markdown text fields where we still want to safely render minimal HTML.
export function sanitizeHtml(html) {
  return DOMPurify.sanitize(html || '', { ALLOWED_TAGS, ALLOWED_ATTR });
}
